import { useMsal } from '@azure/msal-react';
import { tokenRequest } from 'src/msal-constants';
import Storage from 'src/utils/storage/storage';
import { useAppDispatch, useAppSelector } from './app-hooks';
import { IS_TOKEN_SET } from '../store/actions/types';

function useRequestAccessToken() {
  const { instance, accounts } = useMsal();
  const appDispatch = useAppDispatch();
  const request = {
    ...tokenRequest,
    account: accounts[0]
  };

  function aquireSilentToken() {
    instance
      .acquireTokenSilent(request)
      .then((response) => {
        Storage.setToken(response.accessToken);
        // add token to redux
        appDispatch({
          type: IS_TOKEN_SET,
          value: {
            token_value: response.accessToken,
            is_token_set: true
          }
        });
      })
      .catch((e) => {
        console.log('token failed reason-->', e);
      });
  }
  function getAccessToken() {
    aquireSilentToken();
    setInterval(() => aquireSilentToken(), 60000 * 10);
  }
  return getAccessToken;
}

export default useRequestAccessToken;
